import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextButton } from '@oneaudi/unified-web-components';
import { useSelector } from 'react-redux';
import {
  NoOffersSection,
  NoOffersWrapper,
  NoOffersTitle,
  Ctas,
  NoOfferText,
} from './NoOffers.styles';
import { ORIGIN_URL } from '../../constants/environment';
import { selectZipCode } from '../../reducers/zipCodeReducer';

const NoOffers: React.FC = () => {
  const { t } = useTranslation();

  const { market } = useSelector(selectZipCode);

  const isCaMarket = market === 'CA';
  const inventoryURL = `${ORIGIN_URL}/en/inventory/`;
  const contactDealerURL = isCaMarket
    ? 'https://www.audi.ca/en/forms/contact-dealer/?dealer_id=49&partner_id=&dag=&modelid=&source=special'
    : '#contact_general';
  const title = isCaMarket ? t('promo.noOffers.titleCa') : t('promo.noOffers.title');
  return (
    <NoOffersSection>
      <NoOffersWrapper>
        <NoOffersTitle>{title}</NoOffersTitle>
        <NoOfferText>{t('promo.noOffers.description')}</NoOfferText>
        <Ctas>
          <TextButton variant="secondary" href={inventoryURL} isFullWidth>
            {t('promo.noOffers.browseInventory')}
          </TextButton>
          <TextButton href={contactDealerURL} variant="secondary" isFullWidth>
            {t('promo.noOffers.contactDealer')}
          </TextButton>
        </Ctas>
      </NoOffersWrapper>
    </NoOffersSection>
  );
};

export default NoOffers;
